import { useEventSource } from "@/utils/sse";
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { scheduleKeys } from "@/api/schedule";

const AGGREGATE_CHANGED_SSE = "aggregateChanged";

export const useCareSSEHandlers = () => {
  const queryClient = useQueryClient();

  // NOTE: videoCall is not a "changed aggregate", so this is standalone logic
  const videoCallHandler = {
    relevantEvents: ["videoCallStarted", "videoCallEnded"],
    handler: () => {
      void queryClient.invalidateQueries({ queryKey: ["callStatus"] });
    },
  };

  const [logisticsEventHandlers] = useState(() => [
    {
      relevantEvents: [AGGREGATE_CHANGED_SSE],
      handler: () => {
        void queryClient.invalidateQueries({ queryKey: scheduleKeys.all });
      },
    },
    videoCallHandler,
  ]);
  useEventSource("logistics", logisticsEventHandlers);
};
